import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { formatTime } from "@madmedical/utils";
import { Box, Text } from "native-base";
import { useTranslation } from "@madmedical/i18n";
import ReactTable from "../molecules/ReactTable";
import ActionButton from "../molecules/ActionButton";
import { formatType } from "../util/insulinFormatters";
const InsulinReminderTable = ({ data, onDeletePress, onEditPress }) => {
    const { t } = useTranslation();
    const columns = useMemo(() => [
        {
            Header: t("appointment"),
            accessor: "firstOccurrence",
            width: "100px",
            Cell: ({ value }) => value ? _jsx(_Fragment, { children: formatTime(value) }) : _jsx(Box, { children: "-" }),
        },
        {
            Header: t("type"),
            accessor: "insulinType",
            width: "30%",
            minWidth: 100,
            Cell: ({ value }) => value ? _jsx(Box, { children: formatType(value) }) : _jsx(Box, { children: "-" }),
        },
        {
            Header: t("comment"),
            accessor: "comment",
            width: "50%",
            Cell: ({ value }) => value ? (_jsx(Text, Object.assign({ isTruncated: true, noOfLines: 3, maxWidth: "95%" }, { children: value }))) : (_jsx(Box, { children: "-" })),
        },
        {
            Header: "",
            id: "action",
            width: 40,
            Cell: ({ row: { original: measurement }, }) => (_jsx(Box, Object.assign({ flexDirection: "row", justifyContent: "flex-end", w: "full" }, { children: _jsx(ActionButton, { size: "xs", actions: (measurement === null || measurement === void 0 ? void 0 : measurement.editable)
                        ? [
                            {
                                text: t("edit"),
                                iconName: "edit",
                                onPress: () => {
                                    onEditPress === null || onEditPress === void 0 ? void 0 : onEditPress(measurement);
                                },
                            },
                            {
                                text: t("delete"),
                                iconName: "trashCan",
                                onPress: () => {
                                    onDeletePress(measurement.id);
                                },
                            },
                        ]
                        : [] }) }))),
        },
    ], [onDeletePress, onEditPress, t]);
    return _jsx(ReactTable, { columns: columns, data: data });
};
export default InsulinReminderTable;
